import axios from "axios";
import {authtoken_app} from '@/values/private';

export default {
  namespaced: true,
  state: {
    isReceiving: null
  },
  mutations: {
    DO_NOTHING(state) {
      state.isReceiving = false;
    },
  },
  actions: {
    async getBillRequest({dispatch}, id) {
      try{
        dispatch("doNothing");
        let url = 'https://api.accountxc.com:3110/print-api/get/bill/' + id;
        let headers = {'Content-Type': 'application/json', 'authtoken': authtoken_app};
        let response = await axios({method: "get", url: url, headers: headers});
        return response.data;
      }
      catch(e){
        return null;
      }

    },
    async getGLReportISRequest({dispatch}, id) {
      try{
        dispatch("doNothing");
        let url = 'https://api.accountxc.com:3110/print-api/get/gl-report/is/' + id;
        let headers = {'Content-Type': 'application/json', 'authtoken': authtoken_app};
        let response = await axios({method: "get", url: url, headers: headers});
        return response.data;
      }
      catch(e){
        return null;
      }

    },
    async getGLReportBSRequest({dispatch}, id) {
      try{
        dispatch("doNothing");
        let url = 'https://api.accountxc.com:3110/print-api/get/gl-report/bs/' + id;
        let headers = {'Content-Type': 'application/json', 'authtoken': authtoken_app};
        let response = await axios({method: "get", url: url, headers: headers});
        return response.data;
      }
      catch(e){
        return null;
      }

    },
    async getGLReportGLRequest({dispatch}, id) {
      try{
        dispatch("doNothing");
        let url = 'https://api.accountxc.com:3110/print-api/get/gl-report/gl/' + id;
        let headers = {'Content-Type': 'application/json', 'authtoken': authtoken_app};
        let response = await axios({method: "get", url: url, headers: headers});
        return response.data;
      }
      catch(e){
        return null;
      }

    },
    async getInvoiceRequest({dispatch}, id) {
      try{
        dispatch("doNothing");
        let url = 'https://api.accountxc.com:3110/print-api/get/invoice/' + id;
        let headers = {'Content-Type': 'application/json', 'authtoken': authtoken_app};
        let response = await axios({method: "get", url: url, headers: headers});
        return response.data;
      }
      catch(e){
        return null;
      }

    },
    async getCustomerOpenInvoiceRequest({dispatch}, id) {
      try{
        dispatch("doNothing");
        let url = 'https://api.accountxc.com:3110/print-api/get/customer/open-invoices/' + id;
        let headers = {'Content-Type': 'application/json', 'authtoken': authtoken_app};
        let response = await axios({method: "get", url: url, headers: headers});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getSalesRepOpenOrderRequest({dispatch}, id) {
      try{
        dispatch("doNothing");
        let url = 'https://api.accountxc.com:3110/print-api/get/salesrep/open-orders/' + id;
        let headers = {'Content-Type': 'application/json', 'authtoken': authtoken_app};
        let response = await axios({method: "get", url: url, headers: headers});
        return response.data;
      }
      catch(e){
        return null;
      }

    },
    async getSalesOrderRequest({dispatch}, id) {
      try{
        dispatch("doNothing");
        let url = 'https://api.accountxc.com:3110/print-api/get/salesorder/' + id;
        let headers = {'Content-Type': 'application/json', 'authtoken': authtoken_app};
        let response = await axios({method: "get", url: url, headers: headers});
        return response.data;
      }
      catch(e){
        return null;
      }

    },
    async getPayStatementRequest({dispatch}, id) {
      try{
        dispatch("doNothing");
        let url = 'https://api.accountxc.com:3110/print-api/get/paystatement/' + id;
        let headers = {'Content-Type': 'application/json', 'authtoken': authtoken_app};
        let response = await axios({method: "get", url: url, headers: headers});
        return response.data;
      }
      catch(e){
        return null;
      }

    },
    async getCompanyDataRequest({dispatch}, id) {
      dispatch("doNothing");
      let url = 'https://api.accountxc.com:3110/print-api/get/company/data/' + id;
      console.log(url)
      let headers = {'Content-Type': 'application/json', 'authtoken': authtoken_app};
      let response = await axios({method: "get", url: url, headers: headers});
      console.log(response)
      return response.data;
    },
    doNothing({commit}) {
      commit("DO_NOTHING");
    },
  },
};
